<ng-container *ngrxLet="sharedFacade.isLoaded$ as dataLoaded">
  <div *ngIf="!hideShell" [ngStyle]="{ 'pointer-events': !dataLoaded ? 'none' : 'auto' }">
    <span class="zoom"><piqet-angular-header></piqet-angular-header></span>
    <span><piqet-angular-nav-bar [toggleNav]="toggleNav"></piqet-angular-nav-bar></span>
  </div>
  <div>
    <ngx-spinner size="medium" color="#fff" [type]="'line-spin-clockwise-fade'" [fullScreen]="true">
      <div class="spinner-message-container">
        <ng-container *ngIf="spinnerMessage$ | async as message">
          <div [innerHTML]="message"></div>
        </ng-container>
      </div>
    </ngx-spinner>
  </div>
  <router-outlet></router-outlet>
  <piqet-angular-footer *ngIf="!hideShell"></piqet-angular-footer>
</ng-container>
